import { FormHelperText } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { theme } from '../../constants/theme'

export const Error = ({ ...props }) => (
  <CustomError error {...props} />
)

const CustomError = styled(FormHelperText)`
  color: ${theme.colors.ERROR};
`
